import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pb-6 border-b border-gray-400 min-h-[4.5rem]" }
const _hoisted_2 = { class: "screen:divide-y divide-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PublicFilters = _resolveComponent("PublicFilters")!
  const _component_BackendFilters = _resolveComponent("BackendFilters")!
  const _component_DiaryKeyFigures = _resolveComponent("DiaryKeyFigures")!
  const _component_FocusTable = _resolveComponent("FocusTable")!
  const _component_ThoughtsTable = _resolveComponent("ThoughtsTable")!
  const _component_MyBodyTable = _resolveComponent("MyBodyTable")!
  const _component_HealthSegmentTable = _resolveComponent("HealthSegmentTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.isPublic)
          ? (_openBlock(), _createBlock(_component_PublicFilters, { key: 0 }))
          : (_openBlock(), _createBlock(_component_BackendFilters, { key: 1 }))
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_DiaryKeyFigures, { class: "pt-6 screen:pb-8 print:pb-4" }),
        _createVNode(_component_FocusTable, { class: "screen:pt-6 pb-8 break-after-page" }),
        _createVNode(_component_ThoughtsTable, { class: "screen:pt-6 pb-8" }),
        _createVNode(_component_MyBodyTable, { class: "screen:pt-6 pb-8" }),
        _createVNode(_component_HealthSegmentTable, { class: "screen:pt-6 pb-8 break-inside-avoid" })
      ])
    ])
  ]))
}